import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect, useContext } from "react";
import PopupBoxComponent from "../PopupBoxComponent";
import appVersion from "../../version";
import CloudComponent from "../CloudComponent";
import Cloud from "../Cloud";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
import Header from "../pages/Header";
import LanguageSelector from "../pages/LanguageSelector";
// import { LanguageContext } from "../LanguageContext";

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_AUTH_TOKEN;

const translations = {
  en: {
    title: "Are you a Cyber Victim?",
    subtitle: "Select one of these",
    lostMoney: "I lost money",
    noLostMoney: "I did not lose money",
    selectLanguage: "Select Language:",
    errorSelectOption: "Please select an option before proceeding.",
    modalText:
      "For non-financial complaints, you have been redirected to the National Cyber Crime Portal",
    ok: "OK",
    version: "Version",
  },
  Hi: {
    title: "क्या आप साइबर पीड़ित हैं?",
    subtitle: "इनमें से एक चुनें",
    lostMoney: "मेरा पैसा खो गया",
    noLostMoney: "मेरा पैसा नहीं खोया",
    selectLanguage: "भाषा चुनें:",
    errorSelectOption: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    modalText:
      "गैर-वित्तीय शिकायतों के लिए, आपको राष्ट्रीय साइबर अपराध पोर्टल पर रीडायरेक्ट किया गया है",
    ok: "ठीक है",
    version: "संस्करण",
  },
  Kn: {
    title: "ನೀವು ಸೈಬರ್ ಅಪರಾಧಕ್ಕೆ ಒಳಗಾಗಿದ್ದೀರಾ?",
    subtitle: "ಇವುಗಳಲ್ಲಿ ಒಂದನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    lostMoney: "ನಾನು ಹಣವನ್ನು ಕಳೆದುಕೊಂಡಿದ್ದೇನೆ.",
    noLostMoney: "ನಾನು ಹಣವನ್ನು ಕಳೆದುಕೊಂಡಿಲ್ಲ.",
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    errorSelectOption: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಒಂದು ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ.",
    modalText:
      "ಆರ್ಥಿಕವಲ್ಲದ ದೂರದರ್ಶನಗಳಿಗಾಗಿ, ನಿಮಗೆ ರಾಷ್ಟ್ರೀಯ ಸೈಬರ್ ಅಪರಾಧ ಪೋರ್ಟಲ್ ಗೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗಿದೆ",
    ok: "ಸರಿ",
    version: "ಆವೃತ್ತಿ",
  },
  tulu: {
    title: "ನೀವು ಸೈಬರ್ ಬಾಧಿತಾ?",
    subtitle: "ಒಬ್ಬ ಆಯ್ಕೆ ಮಾಡಿ",
    lostMoney: "ನಾನ್ ಹಣ ಕಳೆಚು",
    noLostMoney: "ನಾನ್ ಹಣ ಕಳೆದಿಲ್ಲ",
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    errorSelectOption: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಒಂದು ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ.",
    modalText:
      "ಆರ್ಥಿಕವಲ್ಲದ ದೂರದರ್ಶನಗಳಿಗಾಗಿ, ನೀವು ರಾಷ್ಟ್ರೀಯ ಸೈಬರ್ ಅಪರಾಧ ಪೋರ್ಟಲ್ ಗೆ ಕಳುಹಿಸಲ್ಪಟ್ಟೀರಿ",
    ok: "ಸರಿ",
    version: "ಆವೃತ್ತಿ",
  },
};

const Help = () => {
  // const location = useLocation();
  // // Accessing the state passed from navigate
  // const { vist_id } = location.state || {};
  const [help, setHelp] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [number, setNumber] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [responseStatus, setResponseStatus] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const selectedLang = Cookies.get("selectedLanguage") || "en";
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const app_ver = appVersion.app_ver;
  const date = appVersion.date;
  const [language, setLanguage] = useState("en");

  const vist_id =Cookies.get("visitor_id");
  console.log(vist_id)
  useEffect(() => {
    const cookieLang = Cookies.get("selectedLanguage") || "en";
    setLanguage(cookieLang);
  }, []);

  // Mapping language codes to audio source files (including Tulu)
  const audioMap = {
    en: "audio/English BOT Audios/cybervictim1.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio1.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio1.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };

  // Update audio source when language changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

  // Define help options with text based on selected language
  const helpOptions = [
    {
      id: "A",
      value: "670fce3010e33775926208",
      label: translations[selectedLang].lostMoney,
    },
    {
      id: "B",
      value: "670fce44708f0764144307",
      label: translations[selectedLang].noLostMoney,
    },
  ];
  const handleHelpOptionClick = async (option, e) => {
    e.preventDefault();
    if (option.disabled) {
      return;
    }
    setHelp(option.id);
    setShowOkButton(true);
    setError("");

    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_help_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f6524562171",
          qtion_num: "0",
          qtion_option: option.id,
          option_val: option.value,
          app_ver: app_ver,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });
      const data = await response.json();
      setResponseStatus(data);

      if (!response.ok) {
        throw new Error("Failed to push data to API");
      }
      setNumber(data?.resp?.comp_mob);
    } catch (err) {
      console.error("Error sending data to API:", err);
    }
  };

  const handleOkClick = (e) => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    e.preventDefault();
    if (help) {
      if (help === "A") {
        if (responseStatus?.resp?.error_code === "0") {
          sessionStorage.setItem("access_id", "65437890753690647985");
          navigate("/login", { replace: true, state: { number: number } });
        }
      } else if (help === "B") {
        setShowModal(true);
      }
    } else {
      setError(translations[selectedLang].errorSelectOption);
      setShowOkButton(false);
    }
  };

  const handleModalOkClick = () => {
    setShowModal(false);
    window.location.href =
      "https://www.cybercrime.gov.in/Webform/Crime_AuthoLogin.aspx";
  };

  // Toggle audio playback
  const toggleAudio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="first-container">
      <Header />
      <LanguageSelector onLanguageChange={setLanguage} />
      <div className="help-container">
        <div className="questionss">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ marginTop: "60px" }}>
              <div style={{ display: "flex",justifyContent: "center" }}>
                <h2
                  style={{
                    marginLeft: "12px",
                    textAlign: "center",
                    marginBottom: "-15px",
                    fontSize: "20px",
                  }}
                >
                  {translations[selectedLang].title}
                </h2>
                <button onClick={toggleAudio} className="audio-button">
                  {isPlaying ? (
                    <FaPause color="White" size={12} style={{ marginBottom: '20px' }}/>
                  ) : (
                    <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>
                  )}
                </button>
              </div>
              <audio ref={audioRef} onEnded={handleAudioEnd}>
                <source src={audioMap[selectedLang]} type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
              <p style={{ textAlign: "center", marginBottom: "25px" }}>
                {translations[selectedLang].subtitle}
              </p>
              <div className="options-container">
                {helpOptions.map((option) => (
                  <button
                    key={option.id}
                    className={`option-buttons ${
                      help === option.id ? "selected" : ""
                    } ${option.disabled ? "disabled" : ""}`}
                    style={{
                      opacity: option.disabled ? 0.5 : 1,
                      cursor: option.disabled ? "not-allowed" : "pointer",
                    }}
                    onClick={(e) => handleHelpOptionClick(option, e)}
                    disabled={option.disabled}
                  >
                    <div className="answer-container">
                      <div
                        className="option"
                        style={{
                          backgroundColor: help === option.id ? "#000" : "#fff",
                          color: help === option.id ? "#fff" : "#000",
                        }}
                      >
                        {option.id}
                      </div>
                      <div
                        className="option-label"
                        style={{ textAlign: "start" }}
                      >
                        {option.label}
                      </div>
                    </div>
                    {help === option.id && (
                      <span className="checkmark">&#10003;</span>
                    )}
                  </button>
                ))}
                <div
                  style={{
                    position: "fixed",
                    bottom: "0",
                    left: "0",
                    zIndex: "0",
                  }}
                >
                  <CloudComponent />
                </div>
                <div
                  style={{
                    position: "fixed",
                    bottom: "0",
                    right: "0",
                    zIndex: "0",
                  }}
                >
                  <Cloud />
                </div>
                {error && <div className="error-message">{error}</div>}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {showOkButton && (
                <button
                  type="button"
                  className="ok-btn"
                  onClick={handleOkClick}
                >
                  {translations[selectedLang].ok}
                </button>
              )}
            </div>
            <p style={{ fontSize: "14px", position: "fixed", bottom: "0" }}>
              {translations[selectedLang].version} : {app_ver} | {date}
            </p>
          </div>
          {responseStatus &&
            responseStatus.resp &&
            responseStatus.resp.error_code === "105" && (
              <PopupBoxComponent responseStatus={responseStatus} />
            )}
          {showModal && (
            <div className="modal" style={{ zIndex: "1000" }}>
              <div className="modal-content">
                <h2>{translations[selectedLang].modalText}</h2>
                <button className="ok-btn" onClick={handleModalOkClick}>
                  {translations[selectedLang].ok}
                </button>
              </div>
            </div>
          )}
        </div>
        {/* {error && <div className="error-msg">{error}</div>} */}
      </div>
      {/* <p className="translate">
        <TranslateComponent />
      </p> */}
    </div>
  );
};

export default Help;
